import React from 'react';
import { useMediaQuery } from 'react-haiku';

import Icon from 'components/Misc/Icon';
import Show from 'components/Show';

import User from 'components/Misc/Header/User';
import Messenger from 'components/Misc/Header/Messenger';

import { ReactComponent as Logo } from 'images/logo.svg';
import { useAppStore } from 'store/useAppStore';

const Header = () => {
	// Use app's store
	const [navigation, setNavigation] = useAppStore(state => [state.navigation, state.setNavigation]);

	// Check if viewing from mobile
	const isMobile = useMediaQuery('(max-width: 768px)');

	return (
		<div className="fixed z-20 top-0 left-0 right-0 px-4 h-14 flex items-center justify-between border-b border-neutral-200 dark:border-neutral-700 bg-white dark:bg-neutral-800 transition-colors">
			<div className="w-auto flex items-center">
				{/* Menu toggle only on mobile */}
				<Show if={isMobile}>
					<Icon
						icon={navigation ? 'close' : 'menu'}
						className="mr-4 text-xl text-neutral-800 dark:text-neutral-400"
						onClick={() => setNavigation(!navigation)}
					/>
				</Show>

				{/* Company's logo */}
				<Logo className="max-h-9 w-full" />
			</div>
			
			<div className="flex space-x-2">
				{/* Messenger toggle */}
				<Messenger />

				{/* User's section */}
				<User />
			</div>
		</div>
	);
};

export default Header;